export const TRIP_INVOICE = {
    BASE_PATH: '/trip/invoice/',
    MAKE_PAYMENT_RECEIVE_PATH(id: string | number) {
        return this.BASE_PATH + `${id}` + '/edit/make-payment-receive';
    },
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    ADD_BUTTON_TITLE: 'Add New Trip Sales Order Invoice',
    LIST_PAGE_TITLE: 'Trip Sales Order List',
    EDIT_PAGE_TITLE: 'Edit Trip Sales Order',
    GET_ALL: 'trip/invoice',
    GET_ONE: 'trip/invoice/edit/',
    CREATE: 'trip/invoice/create',
    UPDATE: 'trip/invoice/update/',
    DELETE: 'trip/invoice/delete/',
    ADD_NEW_TITLE: 'Add New Trip Sales Order Invoice',
};
